import React from "react";
import { connect } from "react-redux";
import {FormattedMessage, injectIntl, FormattedHTMLMessage} from "react-intl";
import {withRouter} from "react-router-dom";
import PropTypes from "prop-types";

import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";

import LookListContentHeaderRightSide from "../../list/lookListContentHeaderRightSide";
import {setLookOpened, setLookPageOpened} from "../../../../actions/lookFunctions";
import {ROUTES} from "../../../../routes";
import GroheCartStepper from "./groheCartStepper";

const GroheCartHeaderCommon = (props) => {

  const {title, subTitle, afterTitle, withSave, intl, history, location, isMobile, setLookPageOpened, setLookOpened,
    className, subTitleValues} = props;

  const closeCartClick = () => {
    setLookPageOpened("");
    setLookOpened(null);
    history.push(ROUTES.home);
  }

  return (
    <header className={"gc-header " + (className || "") + (!subTitle && isMobile ? "gc-header--no-sub-title" : "")}>
      <div className="gc-header__cell">
        {isMobile ? (
          <div className="ll-icon" onClick={closeCartClick}>
            <IconButton aria-label={intl.formatMessage({id:"look.list.header.saveButton"})}
                        className="look-icon look-icon--small">
              <CloseIcon />
            </IconButton>
          </div>
        ) : null}
      </div>
      <div className="gc-header__cell gc-header__cell--main">
        <h1 className="gc-header__title">
          <FormattedMessage id={title}/> {afterTitle}
        </h1>
        {subTitle ? (
          <h2 className="gc-header__sub-title">
            <FormattedHTMLMessage id={subTitle} values={subTitleValues}/>
          </h2>
        ) : null}
      </div>
      {location && (location.pathname !== ROUTES.cartSuccess) ? (
        <div className="gc-header__cell">
          <LookListContentHeaderRightSide withoutSave={!withSave}/>
          {withSave ? null : <GroheCartStepper/>}
        </div>
      ) : null}
    </header>
  )
};

GroheCartHeaderCommon.propTypes = {
  title: PropTypes.string.isRequired,
  subTitle: PropTypes.string,
  className: PropTypes.string,
  afterTitle: PropTypes.any,
  withSave: PropTypes.bool,
  subTitleValues: PropTypes.object,
};

const mapStateToProps = (store) => {
  const {isMobile} = store.serverState;
  return {
    isMobile,
  };
};

const mapDispatchToProps = {
  setLookPageOpened,
  setLookOpened,
};

export default injectIntl(
  withRouter(
    connect(mapStateToProps, mapDispatchToProps)(GroheCartHeaderCommon)
  )
)
